import { useMutation } from "@apollo/react-hooks";
import { Modal, Stack } from "@shopify/polaris";
import React, { useCallback } from "react";
import { MARK_AMAZON_IDEA_STATUS_DONE } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";

export default function MarkAmazonIdeaStatusDone({ open, onClose, ids, onCompleted }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [setDelay] = useTimeout();
    const [markStatusDone, { loading }] = useMutation(
        MARK_AMAZON_IDEA_STATUS_DONE,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Mark amazon idea's status Done successfully",
                    err: false,
                });

                onClose();
                onCompleted && onCompleted();
                setDelay(() => {
                    refetch && refetch();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        markStatusDone({
            variables: {
                ids,
            },
        });
    }, [ids]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Mark Amazon Idea's status Done"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <Stack vertical>
                <p>Are you sure you want to mark this Idea as Done?</p>
            </Stack>
        </Modal>
    );
}
